import { createContext, useContext } from 'react';

const AddGuestsStaticContext = createContext(null);

export function AddGuestsStaticProvider({ children, value }) {
    return (
        <AddGuestsStaticContext.Provider value={value}>
            {children}
        </AddGuestsStaticContext.Provider>
    );
}

export function useAddGuestsStatic() {
    const contextValue = useContext(AddGuestsStaticContext);

    if (contextValue === null) {
        throw new Error('useAddGuestsStatic must be used within AddGuestsStaticProvider');
    }

    return contextValue;
}
